module.exports = __webpack_public_path__ + "img/20190222_183706_004.fd059764.jpg";